<template>
  <kst-container class="kst-purchase-details">
    <kst-form 
      :loading="isLoading" 
      :title="title"
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>
      
      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
          <Total :data="data"/>
        </b-tab-item>
        <b-tab-item :label="tabs.ReceiveList">
          <ReceiveRelated :items="data.ReceiveList" :purchaseId="data.ID"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../PurchaseInfo.js";
import Model from "../PurchaseModel.js";

import Action from "./PurchaseDetails_Action";
import Details from "./PurchaseDetails_Details";
import Items from "./PurchaseDetails_Items";
import Total from "./PurchaseDetails_Total";
import ReceiveRelated from "@/components/Receive/Related/ReceiveRelated";

import Services from "../PurchaseServices.js";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    Items,
    Total,
    ReceiveRelated
  },
  data: () => ({
    data: {},
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details,
      ReceiveList: Info.Tabs.ReceiveList
    },
    // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};
      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },
    loadDetails(id) {
      const options = { withpackagings: 1, withreceiving: 1, withreceivingcount: 1 };
      const config = Services.getPurchaseDetails(id, options);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      this.data = data;
      Model.setDetailsByStatus(this.data);

      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }

      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }
  }
}
</script>